var debounce = function debounce(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      callback.apply(void 0, args);
    }, delay);
  };
};
var handleScroll = function handleScroll() {
  var _document$body;
  var header = document.querySelector('#masthead');
  var headerTop = header === null || header === void 0 ? void 0 : header.querySelector('.header-top');
  console.log(header);
  if (!header || !headerTop) return;
  header === null || header === void 0 || header.style.setProperty('--header-top-height', "".concat(headerTop.clientHeight, "px"));
  (_document$body = document.body) === null || _document$body === void 0 || _document$body.style.setProperty('--header-height', "".concat(header.clientHeight, "px"));
  if (window.scrollY > 0) {
    var _document$body2;
    header.classList.add('scrolled');
    (_document$body2 = document.body) === null || _document$body2 === void 0 || _document$body2.classList.add('scrolled');
  } else {
    var _document$body3;
    header.classList.remove('scrolled');
    (_document$body3 = document.body) === null || _document$body3 === void 0 || _document$body3.classList.remove('scrolled');
  }
};
export default function initStickyHeader() {
  handleScroll();
  window.addEventListener('scroll', debounce(handleScroll));
}